import React, {useEffect, useState} from 'react';
import {
    YourPagesWrapper,
    PagesList,
} from './StyledComponents';
import {fabric} from 'fabric';
import PagesSection from "./PagesSection";
import {useDispatch, useSelector} from "react-redux";
import {setActiveSheet} from "../store/reducers/activeSheet";
import {addNewSheet, updateSheetObjects, updateSheetThumbnail} from "../store/reducers/availableSheets";
import {createThumbnail, setCanvasBackground} from "../utils/helpers";
import Sheet from "../utils/sheet";
import {updateUndoRedoState} from "../utils/undo-redo";

function YourPage({togglePage, activeSheetIndex, resizeCanvas, canvasWrapperRef}) {
    const { sheets } = useSelector((state) => state.availableSheets);
    const { canvas } = useSelector((state) => state.canvas);
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const [activeIndex, setActiveIndex] = useState();
    const [canvasBackgroundImage, setCanvasBackgroundImage] = useState(null);
    const [backgroundToggle, setBackgroundToggle] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        setActiveIndex(activeSheetIndex);
    }, [activeSheetIndex]);

    useEffect(() => {
        if (activeSheet) {
            const { backgroundImage } = activeSheet;
            setCanvasBackgroundImage(backgroundImage);
        }
    }, [activeSheet]);

    const switchSheet = (index,tmpSheets=false) => {
        if (index === activeIndex && !tmpSheets) {
            return;
        }
        canvas.discardActiveObject().renderAll();

        const sheetsArr = [...(tmpSheets || sheets)];
        const currentSheet = { ...sheetsArr[activeIndex] };
        const newSheet = { ...sheetsArr[index] };

        dispatch(setActiveSheet(newSheet));

        if(!tmpSheets){
        dispatch(updateSheetObjects({
            sheetId: currentSheet.id,
            objectList: [...canvas.getObjects()],
        }));
        }


        if (backgroundToggle) {
            canvas.backgroundColor = newSheet.backgroundColor;
        }
        canvas._objects = [];

        if (!checkObjectListCanvasSourceCorrect(newSheet.objects)) {
            reAddObjects(newSheet.objects);
            if(newSheet.backgroundImage) canvas.backgroundImage = newSheet.backgroundImage;
            else{
                canvas.backgroundImage = null;
            }
        } else {
            if(newSheet.objects.length && !(newSheet.objects[0] instanceof fabric.Object)) {
                fabric.util.enlivenObjects(newSheet.objects, function(objects) {
                    canvas.add(...objects)
                });
            }
            else{
                canvas._objects = [...newSheet.objects];
            }

            if(newSheet.backgroundImage) canvas.backgroundImage = newSheet.backgroundImage;
            else{
                canvas.backgroundImage = null;
            }
        }
        setActiveIndex(index);
        canvas?.renderAll()
        resizeCanvas()
    };


    const addSheet = (num) => {
        debugger
        let size = {height: 534, width: 800};
        let actualSize = {width:18, height:12};

        if (canvas.getActiveObject()) {
            canvas.discardActiveObject().renderAll();
        }
        const sheetList = [...sheets];
        if(sheetList.length){
            let tempSize = sheetList[0].sheetTemplate.actualSize;
            size = {...sheetList[0].size}
            actualSize = {...tempSize};
        }
        const newSheet = new Sheet(size, sheetList[0].sheetTemplate);
        dispatch(addNewSheet({
            currentSheetList: sheetList,
            newSheet,
            index: num,
        }));
        dispatch(updateSheetObjects({
            sheetId: activeSheet.id,
            objectList: [...canvas.getObjects()],
        }));
        let backgroundImage = sheetList[0].backgroundImage;
        canvas.backgroundColor = 'white';
        canvas._objects = [];
        canvas.backgroundImage = sheetList[0].backgroundImage;
        canvas.setZoom(newSheet.zoom);
        canvas.setHeight(size.height * newSheet.zoom);
        canvas.setWidth(size.width * newSheet.zoom);
        canvas.renderAll();
        if (backgroundImage) {
            setTimeout(()=>{
                setCanvasBackground(canvas, backgroundImage.getSrc(), dispatch, newSheet)
            },10)
        }
        dispatch(updateSheetObjects({
            sheetId: newSheet.id,
            objectList: [...canvas.getObjects()],
        }));

        createThumbnail(canvas).then((thumbnail) => dispatch(updateSheetThumbnail({
            sheetId: newSheet.id,
            thumbnail,
        })));
        dispatch(setActiveSheet(newSheet));
        setActiveIndex(num);
        resizeCanvas()
        updateUndoRedoState('init', 'init', canvas, window.activeSheet, dispatch);
    };

    const checkObjectListCanvasSourceCorrect = (objectList) => {
        let isCorrect = true;
        objectList.forEach((obj) => {
            if (obj.hasOwnProperty('addToSource') && obj?.addToSource) {
                isCorrect = false;
            }
        });
        return isCorrect;
    };

    const reAddObjects = (objectList) => {
        objectList.forEach((obj) => {
            obj.addToSource = false;
            obj.generateThumbnail = false;
            canvas.add(obj).renderAll();
        });
    };
    return (
        <>
            <YourPagesWrapper className={`toolbar_sub_menu ${togglePage ? 'pages-h-100' : 'pages-h-0'}`}>
                <PagesList>
                    <PagesSection sheets={sheets} addSheet={addSheet} switchSheet={switchSheet} activeIndex={activeIndex}/>
                </PagesList>
            </YourPagesWrapper>
        </>
    );
}

export default YourPage;